import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { positionDropdown } from '../../../../common/dropdown'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import TextEllipsis from '../../../../common/textEllipsis'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { EMPTY_VALUE, Z_INDEX } from '../../../../utils/common'
import { TitleComponent } from '../../../common/html/TitleComponent'
import {
  changeActivePortfolio,
  loadingYourPortfolio,
  selectPortfolio,
} from '../store/slice'

export const Header = ({ isActiveFeature }) => {
  const dispatch = useDispatch()

  const loadingSaved = useSelector(loadingYourPortfolio('getPortfolio'))
  const dataSaved = useSelector(selectPortfolio('data'))
  const activePortfolio = useSelector(selectPortfolio('activePortfolio'))

  //Actions
  const handelSelectPortfolio = (value) => {
    dispatch(changeActivePortfolio(value))
  }

  if (loadingSaved) return <></>
  return (
    <>
      <div className="dFlex justifyContentBetween alignItemsCenter gap2">
        <TitleComponent
          title="dashboard.yourPortfolio.title"
          style={{ whiteSpace: 'nowrap' }}
        />
        {!isActiveFeature && !!dataSaved.length && (
          <div className="flex1">
            <SelectCustom
              renderActiveItem={() => (
                <ActiveItem name={activePortfolio?.label} />
              )}
              data={dataSaved}
              chooseItem={handelSelectPortfolio}
              style={{
                borderColor: 'transparent',
                paddingLeft: 4,
                paddingRight: 0,
                justifyContent: 'end',
              }}
              styleDropdown={{
                maxWidth: 400,
                maxHeight: 600,
              }}
              renderDropdownItem={(item, onClickItem) => (
                <ItemPortfolio
                  item={item}
                  onClick={() => onClickItem(item)}
                  isActive={activePortfolio.value === item.value}
                />
              )}
              iconWhenShowDropList="icon-arrow-top-bold"
              iconWhenHiddenDropList="icon-arrow-bottom-bold"
              iconNoPosition
              dropdownPosition={positionDropdown.BOTTOM_END_LEFT}
            />
          </div>
        )}
      </div>
    </>
  )
}

const styles = {
  ACTIVE: {
    color: '#0553A5',
    backgroundColor: '#E5F2FF',
  },
  INACTIVE: {
    color: '#191D25',
    backgroundColor: '',
  },
}

export const ItemPortfolio = ({ item, onClick, isActive }) => {
  const [style, setStyle] = useState(
    item.isActive ? styles.ACTIVE : styles.INACTIVE,
  )

  const onMouseEnter = () => {
    setStyle(styles.ACTIVE)
  }

  const onMouseLeave = () => {
    setStyle(styles.INACTIVE)
  }
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="cursorPointer"
      style={{
        color: isActive ? '#0553A5' : style.color,
        backgroundColor: style.backgroundColor,
        fontWeight: isActive ? 500 : 400,
      }}
      onClick={onClick}
    >
      <Element style={{ padding: '4px 12px', maxWidth: 400 }}>
        <TextEllipsis
          text={item?.label || EMPTY_VALUE}
          zIndexTooltip={Z_INDEX.MODAL + 1}
        />
      </Element>
    </div>
  )
}

export const ActiveItem = ({ name }) => {
  return (
    <>
      <Element
        className="fw600"
        style={{
          lineHeight: '16px',
        }}
      >
        <TextEllipsisStaticLine text={name} lineClamp={1} />
      </Element>
    </>
  )
}
